import clsx from 'clsx'

export const ModuleIconColor = {
  PRIMARY: 'primary',
  ON_COLOR: 'on-color'
} as const

export type ModuleIconColor = (typeof ModuleIconColor)[keyof typeof ModuleIconColor]

export const ModuleIconType = {
  W2_MASTER: 'w2-master',
  RECO_MEDIA: 'reco-media',
  MEDIA_DRIVER: 'media-driver',
  UGC_INTELLIGENCE: 'ugc-intelligence',
  FINDEE: 'findee',
  TAG_TRAIL: 'tag-trail',
  DATA_INSIGHT: 'data-insight',
  AI_STAFF: 'ai-staff'
} as const

export type ModuleIconType = (typeof ModuleIconType)[keyof typeof ModuleIconType]

const moduleIconOnColorWidth = (type: ModuleIconType): string => {
  switch (type) {
    case ModuleIconType.W2_MASTER:
      return 'w-14.5 min-w-14.5'
    case ModuleIconType.RECO_MEDIA:
      return 'w-15.25 min-w-15.25'
    case ModuleIconType.MEDIA_DRIVER:
      return 'w-19.25 min-w-19.25'
    case ModuleIconType.UGC_INTELLIGENCE:
      return 'w-20.25 min-w-20.25'
    case ModuleIconType.FINDEE:
      return 'w-9.25 min-w-9.25'
    case ModuleIconType.TAG_TRAIL:
      return 'w-11.5 min-w-11.5'
    case ModuleIconType.DATA_INSIGHT:
      return 'w-16 min-w-16'
    case ModuleIconType.AI_STAFF:
      return 'w-14 min-w-14'
  }
}

const moduleIconWidth = (type: ModuleIconType): string => {
  switch (type) {
    case ModuleIconType.W2_MASTER:
      return 'w-21 min-w-21'
    case ModuleIconType.RECO_MEDIA:
      return 'w-[87px] min-w-[87px]'
    case ModuleIconType.MEDIA_DRIVER:
      return 'w-[111px] min-w-[111px]'
    case ModuleIconType.UGC_INTELLIGENCE:
      return 'w-[111px] min-w-[111px]'
    case ModuleIconType.FINDEE:
      return 'w-9.25 min-w-9.25'
    case ModuleIconType.TAG_TRAIL:
      return 'w-11.5 min-w-11.5'
    case ModuleIconType.DATA_INSIGHT:
      return 'w-16 min-w-16'
    case ModuleIconType.AI_STAFF:
      return 'w-14 min-w-14'
  }
}

interface Props {
  color?: ModuleIconColor
  activeColor?: ModuleIconColor
  type: ModuleIconType
}

const ModuleIcon = ({ color = ModuleIconColor.PRIMARY, type }: Props) => {
  return (
    <>
      <svg
        className={clsx(
          'inline-block',
          color == ModuleIconColor.ON_COLOR
            ? `fill-on-color h-3.5 min-h-3.5 ${moduleIconOnColorWidth(type)}`
            : `h-5 min-h-5 ${moduleIconWidth(type)}`
        )}
      >
        <use
          xlinkHref={`/assets/icons.svg#${type}${color == ModuleIconColor.PRIMARY ? '' : `-fill`}`}
        ></use>
      </svg>
    </>
  )
}
export default ModuleIcon
